// extracted by mini-css-extract-plugin
export var readonly = "_gr-1";
export var star = "_gr-0";